import React from "react";

const Prizes = () => {
    return (
        <>
                 <div className='p-5 mx-5 bg-gradient-to-b from-[#e2ce9d] to-[#f9b866]'>
                 <div className='max-w-4xl mx-auto'>
        <div className='mx-auto mt-5 text-center text-2xl font-[Bold] text-[#503854]'>
NAGRODY </div>
<div className='p-1 w-full mt-5 drop-shadow-xl bg-[#503854] rounded' />
        <div className='mx-auto mt-5 text-center font-[Light]'>

        ZA UDZIAŁ W AKCJI PODSUMOWANIA ROKU CZEKAJĄ NA WAS NAGRODY UFUNDOWANE PRZEZ NASZYCH PARTNERÓW: SKLEP WUJO POZNAŃ ORAZ RAPGRINDER.PL.

DO WYGRANIA SĄ VOUCHERY* OD WUJO POZNAŃ / RAPGRINDER.PL NA KWOTĘ: 300 ZŁ, 200 ZŁ ORAZ 100 ZŁ DO WYKORZYSTANIA W ICH SKLEPIE STACJONARNYM (PÓŁWIEJSKA 27, POZNAŃ) + SPECJALNE LIMITOWANE GRINDERY OD POZNANSKIRAP.COM.
        </div>
        <div className="mx-auto py-3 w-32 mt-5 flex justify-center">
        <img className='py-5 w-auto px-1' src={`${process.env.REACT_APP_API_DOMAIN}/images/voucher200zl.png`} />
        <img src={`${process.env.REACT_APP_API_DOMAIN}/images/voucher100zl.png`} />
        <img className='py-5 px-1' src={`${process.env.REACT_APP_API_DOMAIN}/images/voucher300zl.png`} />
        </div>
        <div className="flex py-3 justify-center">
        <img src={`${process.env.REACT_APP_API_DOMAIN}/images/mlynek.png`} />
        <img className='w-40' src={`${process.env.REACT_APP_API_DOMAIN}/images/rapgrinder_nagrody.png`} />

        </div>
        <div className='mx-auto my-3 text-center text-2xl font-[Bold] text-[#503854]'>

        + LIMITOWANY GRINDER POZNAŃSKIEGO RAPU
DO KAŻDEGO VOUCHERA !</div>
<div className='p-1 w-full mb-5 mt-5 drop-shadow-xl bg-[#503854] rounded' />
        </div>
        </div>
        </>
    )
}

export default Prizes;